<template>
  <div>
    <div class="notice-box">
      <van-notice-bar scrollable color="#FF8F00"
                      left-icon="https://carpool-1301582899.cos.ap-guangzhou.myqcloud.com/activityH5/image/icon-notice.png">
        <div class="notice-font">{{lists.length?'奖励已发放':'参与活动所获得奖励将存入'}}：<b>{{shareParam.nodeType==21?'万顺APP-个人中心-万顺宝-优惠券-代驾':'代驾司机APP-个人中心-我的钱包'}}</b>
        </div>
      </van-notice-bar>
    </div>
    <div class="my-reward-box">
      <div class="list-top-box">
        <div class="reward-list-tab">
          <div class="li" :class="[tabTypeVal=='isRegister'?'cur':'']"
               v-if="acceptData.isRegister==1||acceptData.isRegister==2"
               @click="tabType('isRegister',acceptData.isRegister)">
            新{{shareParam.nodeType==21?'车主':'司机'}}注册
          </div>
          <div class="li" :class="[tabTypeVal=='isAuth'?'cur':'']"
               v-if="acceptData.isAuth==1||acceptData.isAuth==2"
               @click="tabType('isAuth',acceptData.isAuth)">代驾司机认证
          </div>
          <div class="li" :class="[tabTypeVal=='isNewRushOrder'?'cur':'']"
               v-if="acceptData.isNewRushOrder==1||acceptData.isNewRushOrder==2"
               @click="tabType('isNewRushOrder',acceptData.isNewRushOrder)">
            新{{shareParam.nodeType==21?'车主':'司机'}}完单
          </div>
          <div class="li" :class="[tabTypeVal=='isOldRushOrder'?'cur':'']"
               v-if="acceptData.isOldRushOrder==1||acceptData.isOldRushOrder==2"
               @click="tabType('isOldRushOrder',acceptData.isOldRushOrder)">
            老{{shareParam.nodeType==21?'车主':'司机'}}完单
          </div>
          <div class="li" :class="[tabTypeVal=='allCarOwnerRushOrder'?'cur':'']"
               v-if="acceptData.allCarOwnerRushOrder==1||acceptData.allCarOwnerRushOrder==2"
               @click="tabType('allCarOwnerRushOrder',acceptData.allCarOwnerRushOrder)">
            车主完单
          </div>
          <div class="li" :class="[tabTypeVal=='allDriverRushOrder'?'cur':'']"
               v-if="acceptData.allDriverRushOrder==1||acceptData.allDriverRushOrder==2"
               @click="tabType('allDriverRushOrder',acceptData.allDriverRushOrder)">司机完单
          </div>
        </div>
      </div>
      <div class="p10">
        <ticket-list-yao :lists="lists" v-if="lists.length"></ticket-list-yao>
        <complete-jump :paramsData="paramsData" :tabTypeVal="tabTypeVal" :fontShow="fontShow"
                       v-if="!lists.length"></complete-jump>
      </div>
    </div>
    <div class="btn-box">
      <ul>
        <li class="btn-go" @click="goPage" v-if="shareParam.nodeType==21&&fontShow!=2">立即参与</li>
        <div style="width: 10px"></div>
        <li @click="wantToBtn">我也要邀请</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import mobileType from '@/utils/mobileType';
  import browserType from '@/utils/browserType';
  import wx from 'weixin-js-sdk';
  import util from '@/utils/util';
  import TicketListYao from './ticketListYao';
  import CompleteJump from './completeJump';
  import { accept } from '@/apis/activity/common';

  export default {
    components: {
      CompleteJump,
      TicketListYao
    },
    props: ['paramsData', 'acceptData'],
    data() {
      return {
        shareParam: {},
        tabTypeVal: '',
        fontShow: null,
        lists: [],
      };
    },
    watch: {
      paramsData: {
        handler: function (val, oldVal) {
          if (val) {
            let paramsOther = val.paramsOther;
            if (paramsOther) {
              let shareParam = JSON.parse(paramsOther.shareParam);
              this.shareParam = shareParam;
            }
          }
        },
        deep: true,   //true的情况下可以监听对象属性的改变(深度监听)
        immediate: true //该回调将会在侦听开始之后被立即调用(就是该组件运行的时候就调用这个方法)
      },
      acceptData: {
        handler: function (val, oldVal) {
          if (val) {
            console.log(val, 'valvalvalvalval');
            if (val.isRegister == 1 || val.isRegister == 2) {
              this.tabTypeVal = 'isRegister';
              this.fontShow = val.isRegister;
              this.lists = this.acceptData.registerRewardList;
            } else if (val.isAuth == 1 || val.isAuth == 2) {
              this.tabTypeVal = 'isAuth';
              this.fontShow = val.isAuth;
              this.lists = this.acceptData.authRewardList;
            } else if (val.isNewRushOrder == 1 || val.isNewRushOrder == 2) {
              this.tabTypeVal = 'isNewRushOrder';
              this.fontShow = val.isNewRushOrder;
              this.lists = this.acceptData.newOrderRewardList;
            } else if (val.isOldRushOrder == 1 || val.isOldRushOrder == 2) {
              this.tabTypeVal = 'isOldRushOrder';
              this.fontShow = val.isOldRushOrder;
              this.lists = this.acceptData.oldOrderRewardList;
            } else if (val.allDriverRushOrder == 1 || val.allDriverRushOrder == 2) {
              this.tabTypeVal = 'allDriverRushOrder';
              this.fontShow = val.allDriverRushOrder;
              this.lists = this.acceptData.allDriverRewardList;
            } else if (val.allCarOwnerRushOrder == 1 || val.allCarOwnerRushOrder == 2) {
              this.tabTypeVal = 'allCarOwnerRushOrder';
              this.fontShow = val.allCarOwnerRushOrder;
              this.lists = this.acceptData.allCarOwnerRewardList;
            }
          }
        },
        deep: true,   //true的情况下可以监听对象属性的改变(深度监听)
        immediate: true //该回调将会在侦听开始之后被立即调用(就是该组件运行的时候就调用这个方法)
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      //切换tab
      tabType(val, fontShow) {
        this.tabTypeVal = val;
        this.fontShow = fontShow;
        this.acceptFun(val);
      },
      // 接受邀请-登陆后接受邀请
      async acceptFun(val) {
        let params = { ...this.paramsData.params };
        let paramsOther = this.paramsData.paramsOther;
        let userInfoDjsj = this.$storage.getSession('userInfoDjsj') || {};
        let driverId = userInfoDjsj.driverId;
        params.data = util.filterParams({
          activityId: paramsOther.activityId,//活动id
          cityCode: +this.shareParam.isCityCode,//邀请人城市
          userId: this.shareParam.userId,//邀请人userId
          beCityCode: paramsOther.cityCode,//被邀请人城市(本人)
          beUserId: this.shareParam.nodeType == 22 && driverId ? driverId : params.passengerId,//被邀请人id
          nodeType: +this.shareParam.nodeType,//1邀请车主 2邀请乘客 3邀请代驾司机 4邀请代驾车主
        });
        params.data = JSON.stringify(params.data);
        try {
          const data = await accept(params);
          if (data.code == 1) {
            let activityInvite = JSON.parse(data.data).activityInvite;
            if (val == 'isRegister') {
              this.lists = activityInvite.registerRewardList;
            } else if (val == 'isAuth') {
              this.lists = activityInvite.authRewardList;
            } else if (val == 'isNewRushOrder') {
              this.lists = activityInvite.newOrderRewardList;
            } else if (val == 'isOldRushOrder') {
              this.lists = activityInvite.oldOrderRewardList;
            } else if (val == 'allDriverRushOrder') {
              this.lists = activityInvite.allDriverRewardList;
            } else if (val == 'allCarOwnerRushOrder') {
              this.lists = activityInvite.allCarOwnerRewardList;
            } else {
              this.lists = [];
            }
          }
        } catch (error) {
        }
      },
      //跳转活动规则
      goRule() {
        this.$router.push({
          name: 'toActivityRules',
          query: {
            activityId: this.paramsData.paramsOther.activityId,
            cityCode: this.paramsData.paramsOther.cityCode,
          },
        });
      },
      //立即叫代驾
      goPage() {
        wx.miniProgram.reLaunch({
          url: '/pages/index/index'
        });
      },
      //我也要邀请
      wantToBtn() {
        let query = this.$route.query;
        if (this.shareParam.nodeType == 22) {
          let userInfoDjsj = this.$storage.getSession('userInfoDjsj') || {};
          let driverId = userInfoDjsj.driverId;
          query.driverId = driverId;
        }
        this.$router.push({
          path: '/home/shareUniversal',
          query: query,
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  .notice-box {
    /*padding: 10px 10px;*/
    padding: 0 10px;

    .notice-font {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;

      b {
        font-weight: bold;
      }
    }

    .van-notice-bar {
      background: none;
    }

    .van-icon__image {
      width: 20px;
      height: 18px;
    }
  }

  .my-reward-box {
    background: #FFFFFF;
    box-shadow: 0px 1px 6px 0px #FFE3CF;
    border-radius: 12px;
    margin: 10px 10px 46px 10px;

    .list-top-box {
      background: #F5F5F7;
      border-radius: 12px 12px 0px 0px;
      text-align: center;

      .font001 {
        font-size: 12px;
        font-weight: 400;
        color: #E77A50;
        line-height: 18px;
        padding: 0 4px;
        box-sizing: border-box;
      }

      /*.reward-list{*/
      /*  display:flex;*/
      /*  display:-webkit-flex;!*Safari*!*/
      /*  justify-content:space-between;!*水平排布方式*!*/
      /*  align-items:center;!*垂直对齐方式*!*/
      /*}*/

      .reward-list-tab {
        width: 100%;
        overflow: hidden;
        display: -moz-box;
        display: -webkit-box;
        /*display: -o-box;*/
        /*display: box;*/
      }

      .li {
        -webkit-box-flex: 1;
        /*规定框的子元素可伸缩其尺寸。*/
        background: #F5F5F7;
        border-radius: 12px 12px 0px 0px;
        font-size: 16px;
        font-weight: 500;
        color: #919191;
        line-height: 22px;
        padding: 28px 0;
      }

      .cur {
        background: #FFFFFF;
        color: #000000;
      }

      /*.item:first-child {*/
      /*  margin-left: 10px;*/
      /*  width: 200px;*/
      /*  -webkit-box-flex: 0;*/
      /*  !*规定框的子元素不可伸缩其尺寸。*!*/
      /*}*/

    }
  }

  .btn-box {
    box-sizing: border-box;
    padding: 0 24px;


    ul {
      width: 100%;
      box-sizing: border-box;

      li {
        background: linear-gradient(180deg, #FFF9D6 0%, #FFC969 100%);
        box-shadow: 0px 4px 10px 0px rgba(255, 166, 150, 0.82);
        border-radius: 25px;
        font-size: 20px;
        font-weight: 600;
        color: #906000;
        line-height: 28px;
        text-shadow: 0px 2px 3px #DB7F00;
        text-align: center;
        padding: 11px 0;
        margin-top: 24px;
        margin-bottom: 10px;
      }

      .btn-go {
        background: linear-gradient(180deg, #FFDF88 0%, #FF8E64 25%, #FE0602 100%);
        box-shadow: 0px 4px 10px 0px #FF9E96;
        color: #FFFFFF;
        text-shadow: 0px 2px 1px #CD0007;
      }
    }

  }
</style>
